export const config = {
    bucketName: "serenetax",
    dirName: "documents",
    region: "ap-south-1",
    accessKeyId: "AKIAXYKJWDQ7JYQARYWP",
    secretAccessKey: "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",
};
